import React from 'react';
import { Icon, Tooltip } from '@upsales/components';
import BemClass from '@upsales/components/Utils/bemClass';
import { useTranslation } from 'Components/Helpers/translate';
import { copyToClipboardNotify } from 'Services/copyToClipboard';
import './CopyIcon.scss';

/** Put on the element whose hover reveals a `revealOnHover` icon inside it. */
export const COPY_ICON_HOST = 'CopyIcon-host';

type Props = {
	value: string;
	/** Hidden until the pointer is over the nearest `COPY_ICON_HOST` around it. */
	revealOnHover?: boolean;
};

const CopyIcon = ({ value, revealOnHover = false }: Props) => {
	const { t } = useTranslation();
	const classes = new BemClass('CopyIcon');

	return (
		<Tooltip
			title={t('default.copy')}
			distance={20}
			className={classes.mod({ 'reveal-on-hover': revealOnHover }).b()}
		>
			<Icon
				name="copy"
				onClick={event => {
					// The row this sits in may navigate on click.
					event.stopPropagation();
					copyToClipboardNotify(value);
				}}
			/>
		</Tooltip>
	);
};

export default CopyIcon;
